<template>
<div>
  <v-row align="center" justify="center">
    <v-col cols="12" sm="10" md="4">
      <v-card class="elevation-8 pt-12 pb-12 pl-6 pr-6">v3.2.5
        <v-img height="120" contain src="../assets/Pelican_LogoB.png"></v-img>
        <v-card-title v-text="card.cardTitle" class="font-weight-black justify-center"></v-card-title>
        <v-card-subtitle v-text="card.cardSubTitle" class="font-weight-black text-center mt-0"></v-card-subtitle>
        <v-row v-if="card.chipShow" justify="center" align="center">
          <v-chip class="ma-2" outlined>
            <v-icon left color="grey darken-2" v-text="`mdi-account-circle`"></v-icon>
            {{ user.accountId }}
            <v-icon right v-text="`mdi-chevron-down`"></v-icon>
          </v-chip>
        </v-row>
        <router-view :account-id.sync="user.accountId" :password.sync="user.password"></router-view>
      </v-card>
    </v-col>
  </v-row>
</div>
</template>

<script>
const Base64 = require('js-base64').Base64
export default {
  data() {
    return {
      card: {
        cardTitle: "",
        cardSubTitle: "",
        chipShow: false,
      },
      user: {
        accountId: "",
        password: "",
        endsmid: this.$route.query.encryptid,
        dsmid: this.$route.query.dsmid,
        base64en_dsmid: Base64.encode('P' + this.$route.query.dsmid),
      },
    };
  },
  mounted: function() {
    //this.checkPage();
    this.checkPcode();
  },
  created() { //創建時間節點
    let endsmid_token = this.user.endsmid;
    let dsmid_token = this.user.dsmid;
    let base64en_dsmid_token = this.user.base64en_dsmid;
    let page_token = 'T';
    // 設置cookie預設過期時間單位是關閉頁面自動失效
    this.$cookie.set('dsmid_token', dsmid_token, "0");
    this.$cookie.set('endsmid_token', endsmid_token, "0");
    this.$cookie.set('base64en_dsmid_token', base64en_dsmid_token, "0");
    this.$cookie.set('page_token', page_token, "0");
  },
  watch: {
    $route: {
      handler: function(to, from) {
        this.setCard("", "");
        switch (to.name) {
          case "KeyinUser":
            this.setCard("歡迎使用宅配通訂單系統", "", false);
            break;
          case "KeyinPswd":
            this.setCard("歡迎使用宅配通訂單系統", "", true);
            break;
          case "VerifyUser":
            this.setCard("歡迎使用宅配通訂單系統", "");
            break;
        }
      },
      immediate: true,
    },
  },
  methods: {
    setCard(title, subTitle, chipShow) {
      this.card.cardTitle = title;
      this.card.cardSubTitle = subTitle;
      this.card.chipShow = chipShow;
    },
    checkPage: function() {
      if (this.$cookie.get('endsmid_token') === this.$cookie.get('base64en_dsmid_token')) {
        if (this.$cookie.get('page_token') === 'T') {
          this.$router.push({
            name: "KeyinUser"
          });
        }
      } else {
        this.$router.push({
          name: "ErrorPage"
        });
      }
    },
    checkPage2c: function() {
      if (this.$cookie.get('endsmid_token') === this.$cookie.get('base64en_dsmid_token')) {
        if (this.$cookie.get('page_token') === 'T') {
          //let url = 'https://queryapi.e-can.com.tw:9097/EDIQR2Capi/EDIQR2C_Chkdsmid/pass=0000000000&main_id=' + this.$cookie.get('dsmid_token')
          let url = 'https://queryapi2.e-can.com.tw:9091/EDIQR2Capi/EDIQR2C_Chkdsmid/pass=0000000000&main_id=' + this.$cookie.get('dsmid_token');
          this.$axios.get(url).then(response => {
            if (response.data.dsm === '0'){
              let page_token = 'S';
              this.$cookie.set('page_token', page_token, "0");
              this.$router.push({
                name: "InsDSMdata2c"
              });
            }else{
              let page_token = 'S';
              this.$cookie.set('page_token', page_token, "0");
              this.$router.push({
                name: "UpdDSMdata2c"
              });
            }
          }).catch(function(error) {
            this.$router.push({
              name: "ErrorPage"
            });
          })
        }
      } else {
        this.$router.push({
          name: "ErrorPage"
        });
      }
    },
    checkPcode() {
      // 01 11 單，05 15 單，其他
      if ((this.$cookie.get('dsmid_token').substr(1, 2) === '01') || (this.$cookie.get('dsmid_token').substr(1, 2) === '11')) {
        //let url = 'https://queryapi.e-can.com.tw:9091/EDIQRapi/EDIQR_ChkPcode/' + this.$cookie.get('dsmid_token')
        let url = 'https://queryapi2.e-can.com.tw:9091/EDIQRapi/EDIQR_ChkPcode/' + this.$cookie.get('dsmid_token')
        this.$axios.get(url).then(response => {
          console.log('B單：' + this.$cookie.get('dsmid_token'));
          if (response.data.pcode === '0') {
            this.checkPage();
          } else if (response.data.pcode === '1') {
            this.$cookie.set('dsm_type', "2", "0");
            let page_token = 'C';
            this.$cookie.set('page_token', page_token, "0");
            this.$router.push({
              name: "VerifyUser"
            });
          } else {
            this.$router.push({
              name: "ErrorPage"
            });
          }
        }).catch(function(error) {
          this.$router.push({
            name: "ErrorPage"
          });
        })
      } else if ((this.$cookie.get('dsmid_token').substr(1, 2) === '05') || (this.$cookie.get('dsmid_token').substr(1, 2) === '15')) {
        //let url = 'https://queryapi.e-can.com.tw:9097/EDIQR2Capi/EDIQR2C_ChkPcode/' + this.$cookie.get('dsmid_token')
        let url = 'https://queryapi2.e-can.com.tw:9091/EDIQR2Capi/EDIQR2C_ChkPcode/' + this.$cookie.get('dsmid_token');
        this.$axios.get(url).then(response => {
          console.log('C單：' + this.$cookie.get('dsmid_token'));
          if (response.data.pcode === '0') {
            this.checkPage2c();
          } else if (response.data.pcode === '1') {
            this.$cookie.set('dsm_type', "2", "0");
            let page_token = 'S';
            this.$cookie.set('page_token', page_token, "0");
            this.$router.push({
              name: "SerchDSM2c"
            });
          } else {
            this.$router.push({
              name: "ErrorPage"
            });
          }
        }).catch(function(error) {
          this.$router.push({
            name: "ErrorPage"
          });
        })
      } else {
        this.$router.push({
          name: "ErrorPage"
        });
      }

    },
  },
}
</script>
